define('app-Search/modules/resources',['../settings', '../core/service'], function (settings, Service) {
    return {
        run: function () {
            self.Service = new Service(settings.searchStorageKey);

            // Overwrite _renderItem for search results
            $.ui.autocomplete.prototype._renderItem = function (ul, item) {
                ul.addClass('autocompleteOptions'); //ul custom class here

                var isDisabled = !item.enabled ? "ui-state-disabled" : "";

                return $("<li>")
                    .data("ui-autocomplete-item", item)
                    .attr("data-value", item.value)
                    .attr("class", isDisabled)
                    .append("<a>" + item.label + "<span style='float: right; padding-left: 2em;'>" + item.count + "</span></a>")
                    .appendTo(ul);
            };
        }
    }
});

//store the autocomplete value here
autocompleteSelectedValue = "";
autocompleteDefaultValue = "";

function autoComplete(element, retrieveData) {
    $(element).autocomplete({
        minLength: 2,
        delay: 200,
        source: function (request, response) {
            retrieveData(request.term, function (result) { response(result); });
        },
        create: function () {
            $(this)
                .data("ui-autocomplete")
                ._renderMenu = function (ul, items) {
                    if (items.length === 1 && items[0].value === 0) {
                        var notFound = $("<li><h3>Sorry, your location was not found.</h3></li>")
                            .data("ui-autocomplete-item", item);

                        ul.append(notFound);

                        return;
                    }

                    var that = this;
                    var currentCategory = "";
                    var slicedItems = items.slice(0, 4);

                    slicedItems.forEach(function (item) {
                        if (item.type != currentCategory) {
                            var header = $("<li class='ui-autocomplete-category'>" + translateItemType(item.type) + "</li>")
                                .data("ui-autocomplete-item", item);

                            ul.append(header);
                            currentCategory = item.type;
                        }

                        that._renderItemData(ul, item);
                    });
                }
        },

        focus: function () {
            $("#ui-id-1").find("li a").removeClass("selected");
            $("#ui-id-1").find("li a.ui-state-focus").addClass("selected");
        },

        select: function (event, ui) {
            if ($("#searchTab1").hasClass("active")) {
                autocompleteSelectedValue = ui.item.datatag;
                updateSearchButton(element, ui.item.datatag);

                $("#destinationSearchTxt")
                    .val(ui.item.value)
                    .trigger("enterKey");
            } else if ($("#searchTab2").hasClass("active")) {
                var onlyGetHolidayTypeHotel = ',{"type":"ht","value":"f472ce3f-de80-4a05-a0ed-a4723153f63b","description":"Hotel"}';

                autocompleteSelectedValue = ui.item.datatag;
                updateSearchButton(element, autocompleteSelectedValue + onlyGetHolidayTypeHotel);

                $("#hotelSearchTxt")
                    .val(ui.item.value)
                    .trigger("enterKey");
            } else if ($("#searchTab8").hasClass("active")) {
                var onlyGetHolidayTypeSoloTraveller = ',{"type":"ht","value":"bcb15f36-a1e3-48a6-9203-cbaca4325a66","description":"Solo Traveller"}';

                autocompleteSelectedValue = ui.item.datatag;
                updateSearchButton(element, autocompleteSelectedValue + onlyGetHolidayTypeSoloTraveller);

                $("#soloTravellerSearchTxt")
                    .val(ui.item.value)
                    .trigger("enterKey");
            };
        }
    });
};

function updateSearchButton(element, query) {
    var $button = $(element.replace("Txt", "Button")); //results in: #_name_Button, where _name_ is destinationSearch, hotelSearch, etc
    var encodedTags = query;

    if (encodedTags > "") {
        $.ajax({
            url: "/searchservice/getresultcount",
            data: {
                "tags": "[" + encodedTags + "]"
            },
            type: "POST",
            success: function (data) {
                $button.val("See " + data.productCount + " holidays");
            }
        });
    } else {
        $button.val("Search");
    }
}

function camelize(str) {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
            return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
        })
        .replace(/\s+/g, '');
}

// JSON Manipulation and Searching
//return an array of objects according to key, value, or key and value matching
function resources_getObjects(obj, key, val) {
    var objects = [];

    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;

        if (typeof obj[i] == 'object') {
            objects = objects.concat(resources_getObjects(obj[i], key, val));
        } else
            //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
            if (i == key && obj[i] == val || i == key && val == '') { //
                objects.push(obj);
            } else if (obj[i] == val && key == '') {
                //only add if the object is not already in the array
                if (objects.lastIndexOf(obj) == -1) {
                    objects.push(obj);
                }
            }
    }

    return objects;
}

//return an array of values that match on a certain key
function resources_getValues(obj, key) {
    var objects = [];

    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;

        if (typeof obj[i] == 'object') {
            objects = objects.concat(resources_getValues(obj[i], key));
        } else if (i == key) {
            objects.push(obj[i]);
        }
    }

    return objects;
}

//return an array of keys that match on a certain value
function resources_getKeys(obj, val) {
    var objects = [];

    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;

        if (typeof obj[i] == 'object') {
            objects = objects.concat(resources_getKeys(obj[i], val));
        } else if (obj[i] == val) {
            objects.push(i);
        }
    }

    return objects;
}

function translateItemType(itemType) {
    switch (itemType) {
        case "g":
            return "Places";
        case "pc":
            return "Holidays";
        default:
            return itemType;
    }
}

function resources_showHolidayFilter() {
    var jsonData = "";
    var data = $(location).attr('hash');
    if (data != "") {
        var startAt = data.indexOf('[');

        if (startAt >= 0) {
            var endAt = data.lastIndexOf(']');
            var searchTagsRaw = data.substring(startAt, endAt + 1);
            var searchTags = decodeURIComponent(searchTagsRaw);

            if (searchTags != "") {
                jsonData = JSON.parse(searchTags);
            }
        }
    }

    // only show the search master filters if the only search tag is geographic
    // or if this is an 'empty' search
    if (searchTags == '[{"type":"p","value":"2"},{"type":"du","value":"1-999"}]') {
        return true;
    } else {
        var gData = resources_getObjects(jsonData, "type", "g");

        if (jsonData.length == 1 && gData.length == 1) {
            return true;
        }
    }

    return false;
}

function resources_setSummaryText() {
    var holidayTypeTxt = "";
    var geographicTxt = "";
    var departurePointTxt = "";
    var dateTxt = "";
    var durationTxt = "";
    var passengersTxt = "";
    var allTerms = self.Service.allTerms();

    if (allTerms.length > 0) {
        for (var i = 0; i < allTerms.length; i++) {
            switch (allTerms[i].type) {
                case "ht":
                    holidayTypeTxt = allTerms[i].description;

                    break;
                case "g":
                    geographicTxt = allTerms[i].description;

                    break;
                case "pc":
                    geographicTxt = allTerms[i].description;

                    break;
                case "dp":
                    var dpPrefaceTxt = (departurePointTxt.length > 0) ? " or " : "";
                    departurePointTxt += dpPrefaceTxt + allTerms[i].description;

                    break;
                case "sd": //date - only need start date (sd) to get the month
                    var startDate = allTerms[i].value;
                    var mth = startDate.slice(3, 5);
                    var yyyy = startDate.slice(6, 10);
                    dateTxt = monthFullNames[mth - 1] + ", " + yyyy;

                    break;
                case "du": //duration
                    durationTxt = (allTerms[i].value == "1-999") ? "any duration" : allTerms[i].value + " nights";

                    break;
                case "p":
                    passengersTxt = (allTerms[i].value == "1") ? allTerms[i].value + " passenger" : allTerms[i].value + " passengers";

                    break;
            }
        }

        var durationValue = JSON.parse(decodeURIComponent($('#facetDuration').val())).value;
        var htSuffix = (holidayTypeTxt.toLowerCase() == "ocean cruise" || holidayTypeTxt.toLowerCase() == "river cruise") ? "s" : " holidays";
        var searchSummaryStr = "You searched for ";

        durationTxt = (durationValue == "1-999") ? "any duration" : ((durationValue == "28-999") ? "28 or more nights" : durationValue + " nights");
        dateTxt = $('#facetDateField').val();

        searchSummaryStr += (geographicTxt + departurePointTxt + dateTxt + durationTxt == "") ? "<span> all " : "<span>";
        searchSummaryStr += (holidayTypeTxt == "") ? " holidays and cruises</span> " : holidayTypeTxt + htSuffix + "</span>";
        searchSummaryStr += (geographicTxt != "") ? " to <span>" + geographicTxt + "</span>" : "";
        searchSummaryStr += (passengersTxt != "") ? " for <span>" + passengersTxt + "</span>" : "";
        searchSummaryStr += (departurePointTxt != "") ? " departing from <span>" + departurePointTxt + "</span>" : "";
        searchSummaryStr += (dateTxt != "") ? " in <span>" + dateTxt + "</span>" : "";
        searchSummaryStr += (durationTxt != "") ? " for <span>" + durationTxt + "</span>" : "";
        searchSummaryStr += '<span style="width:20px;display:inline-block"></span>';

        $('#searchBreadcrumb').html(searchSummaryStr);
    }
}

var availableDatesDictionary = {};
var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthFullNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function showDatePicker(dateFieldId, appTags) {
    var $dateField = $(dateFieldId);

    $.ajax({
        url: "/searchservice/getavailablemonths",
        data: { tags: "[" + appTags + "]" },
        type: "POST",
        success: function (data) {
            var resultsPage = false;
            var selectedDateTxt = $('#searchTabs>li.active select.dateDropdown').val();

            if (dateFieldId == "#facetDateField") {
                resultsPage = true;
                selectedDateTxt = $dateField.val();
            }

            $.each(data, function (item, obj) {
                var dt = new Date(obj.key);
                var mm = dt.getMonth();
                var monthNo = mm + 1; //because mm returns a 0-based value
                var monthEndDay = new Date(dt.getFullYear(), monthNo, 0).getDate(); // zeroth day of the month is the last day of the previous month
                var formattedMonth = (monthNo >= 10) ? monthNo : "0" + monthNo.toString();

                var codedDate = "{\"type\":\"sd\",\"value\":\"01/" + formattedMonth + "/" + dt.getFullYear() + "\"},{\"type\":\"ed\",\"value\":\"" + monthEndDay + "/" + formattedMonth + "/" + dt.getFullYear() + "\"}";

                var dateAsString = monthNames[mm] + " " + dt.getFullYear();
                availableDatesDictionary[dateAsString] = codedDate;

                //enable all available dates using dateAsString
                if (resultsPage) {
                    $('#facetDateAndDuration .datePickerMonths > div[data-value="' + dateAsString + '"] > a').removeClass('disabled dateSelected').addClass('dateAdd');

                    if (dateAsString == selectedDateTxt) {
                        $('#facetDateAndDuration .datePickerMonths > div > a').removeClass('dateSelected');
                        $('#facetDateAndDuration .datePickerMonths > div[data-value="' + dateAsString + '"] > a').addClass('dateSelected');
                    }
                } else {
                    $('#searchTabs>li.active .datePickerMonths > div[data-value="' + dateAsString + '"] > a').removeClass('disabled dateSelected').addClass('dateAdd');

                    if (dateAsString == selectedDateTxt) {
                        $('#searchTabs>li.active .datePickerMonths > div > a').removeClass('dateSelected');
                        $('#searchTabs>li.active .datePickerMonths > div[data-value="' + dateAsString + '"] > a').addClass('dateSelected');
                    }
                }
            });

            //then set up the click event once we know the dateAdd class has been added where it ought to be.
            $dateField.next().find('.dateAdd').off('click').on("click", function (e) {
                e.preventDefault();

                $dateField.val($(this).attr('value'));
                $dateField.next().slideUp();
                $dateField.trigger('change');
                $('#ocDateField').removeClass("activeDropdown");
                $('.ocDateField .dropArrow').removeClass('test');

            });
        },
        fail: function () {
            console.log("Error retrieving data from server");
        }
    });

    $dateField.next().mouseleave(function (e) {
        setTimeout(function () {
            $dateField.next().slideUp();
            $dateField.parentsUntil('.searchContentInner').find('.activeDropdown').removeClass('activeDropdown');
        }, 250);
    });

    $dateField.next().find('.prev').on("click", function (e) {
        e.preventDefault();

        $(this).closest('.yearPicker').hide();
        $(this).closest('.yearPicker').prev().show();
    });

    $dateField.next().find('.next').on("click", function (e) {
        e.preventDefault();

        $(this).closest('.yearPicker').hide();
        $(this).closest('.yearPicker').next().show();
    });

    $dateField.next().find('.dateReset').off('click').on("click", function (e) {
        e.preventDefault();

        $dateField.val('Any date');
        $dateField.next().slideUp();
        $dateField.trigger('change');
    });
};
